import React, { useContext, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import RenderStatus from "../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { TransferContainerContext } from "./TransferContainer";
import DefaultButton from "../../styles/materialButtonStyle";
import DialogModal from "../../elements/dialogModal/DialogModal";
import TwoFa from "../../elements/twoFa/TwoFa";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { HTTP_STATUSES, TRANSFER_STATUSES, TRANSFER_USER } from "../../../utils/consts";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { useTranslation } from "react-i18next";

import { StyledCol, StyledTableRow } from "../../styles/styledTable";
import { StyledCopy } from "../../styles/styledCopy";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const TransferItem = ({ transfer, action, refetch, setRefetch, reverseAction }) => {
  const { t } = useTranslation("transferPage");

  const { notification, setNotification } = useContext(TransferContainerContext);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [transferActionName, setTransferActionName] = useState("");

  const [currentTransfer, setCurrentTransfer] = useState(null);

  const processTransfer = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    let data = {
      status: transferActionName
    };

    axios.put(`/api/transfers/${currentTransfer.id}`, data, userAuthenticationConfig(false)).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("table.changeTransfer")
        });
        setOpen(false);
        setTransferActionName("");
        setCurrentTransfer(null);
        setRefetch(!refetch);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.detail });
    });
  };

  const handleActionButton = (status, transfer) => {
    setOpen(true);
    setTransferActionName(status);
    setCurrentTransfer(transfer);
  };

  const getActionsButtonByDirection = (action, transfer) => {
    switch (action) {
      case TRANSFER_USER.RECEIVER:
        if (transfer.status?.value !== TRANSFER_STATUSES.PENDING) {
          return null;
        }
        return <div>
          <DefaultButton
            color="transparent"
            border="success"
            onClick={() => handleActionButton(TRANSFER_STATUSES.PROCESSED, transfer)}
          >
            {t("table.processedBtn")}
          </DefaultButton>
          <DefaultButton
            color="transparent"
            border="danger"
            onClick={() => handleActionButton(TRANSFER_STATUSES.FAIL, transfer)}
          >
            {t("table.rejectBtn")}
          </DefaultButton>
        </div>;

      case TRANSFER_USER.SENDER:
        if (transfer.status?.value !== TRANSFER_STATUSES.NEW) {
          return null;
        }
        return <div>
          <DefaultButton
            color="transparent"
            border="success"
            onClick={() => handleActionButton(TRANSFER_STATUSES.PENDING, transfer)}
          >
            {t("table.pendingBtn")}
          </DefaultButton>
          <DefaultButton
            color="transparent"
            border="danger"
            onClick={() => handleActionButton(TRANSFER_STATUSES.FAIL, transfer)}
          >
            {t("table.cancelBtn")}
          </DefaultButton>
        </div>;

      default:
        return null;
    }
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("table.actionConfirmation")}
        content={<TwoFa
          handleSubmit={processTransfer}
          error={error}
        />}
      />

      <StyledTableRow
        scroll="auto"
        className="transfer-table__row"
        col="10"
        cursor="pointer"
      >
        <StyledCol
          inline
          data-title="id"
        >
          <CopyToClipboard
            text={transfer.id}
            onCopy={() => {
              setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
            }}
          >
            <StyledBreakWord as="p">
              {transfer.id} <StyledCopy
              title={t("table.copy")}
              className="icon-light-copy"
            />
            </StyledBreakWord>
          </CopyToClipboard>
        </StyledCol>
        <StyledCol
          inline
          data-title={`${t("table.email")} ${reverseAction}`}
        >
          <CopyToClipboard
            text={transfer[reverseAction]?.email || ""}
            onCopy={() => {
              setNotification({ ...notification, visible: true, type: "success", message: t("table.copied") });
            }}
          >
            <StyledBreakWord as="p">
              {transfer[reverseAction]?.email || "--"} <StyledCopy
              title={t("table.copy")}
              className="icon-light-copy"
            />
            </StyledBreakWord>
          </CopyToClipboard>
        </StyledCol>
        <StyledCol data-title={t("table.service")}>
          {transfer.service?.name || "--"}
        </StyledCol>
        <StyledCol data-title={t("table.currency")}>
          {transfer.currency?.asset}
        </StyledCol>
        <StyledCol data-title={t("table.amount")}>
          {transfer.amount}
        </StyledCol>
        <StyledCol
          inline
          data-title={t("table.status")}
        >
          {transfer.status ? <RenderStatus status={transfer.status.value} /> : "--"}
        </StyledCol>
        <StyledCol data-title={t("table.createdAt")}>
          {TimestampToDateMoment(transfer.createdAt)}
        </StyledCol>
        <StyledCol data-title={t("table.updatedAt")}>
          {TimestampToDateMoment(transfer.updatedAt)}
        </StyledCol>
        <StyledCol data-title={t("table.note")} className="transfer-table__note">
          {transfer.note}
        </StyledCol>
        <StyledCol data-title={t("table.actions")} className="transfer-table__actions">
          {getActionsButtonByDirection(action, transfer)}
        </StyledCol>
      </StyledTableRow>
    </>
  );
};

export default TransferItem;